import { render } from "./BardBotSettings.vue?vue&type=template&id=3ad7bb94"
import script from "./BardBotSettings.vue?vue&type=script&lang=js"
export * from "./BardBotSettings.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__